import { FileTextOutlined, TeamOutlined } from '@ant-design/icons';
import StatsCard from 'components/new-ui/base/stats-card/StatsCard';
import TruckIconOutlined from 'components/icons/TruckIconOutlined';
import WeightIconOutlined from 'components/icons/WeightIconOutlined';
import { StatisticsProps } from 'types/common';

type Props = StatisticsProps & {};

const FreightAdminStatsCards = ({ data, error, loading, refetch }: Props) => {
    const teamsCount = data?.teamsStatistic.totalTeams;
    const activeManifests = data?.manifestsStatistic.activeManifests;
    const activeJobs = data?.jobsStatistic.activeJobs;
    const activeInvoices = data?.invoicesStatistic.activeInvoices;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 24,
            }}
        >
            <StatsCard
                label="Teams"
                type="warning"
                icon={<TeamOutlined style={{ color: 'var(--orange-6)' }} />}
                count={teamsCount}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Active Manifests"
                type="success"
                icon={<TruckIconOutlined style={{ color: 'var(--polar-green-6)' }} />}
                count={activeManifests}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Active Jobs"
                type="default"
                icon={<WeightIconOutlined style={{ color: 'var(--blue-7)' }} />}
                count={activeJobs}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Active Invoices"
                type="processing"
                icon={<FileTextOutlined style={{ color: 'var(--purple-6)' }} />}
                count={activeInvoices}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />
        </div>
    );
};

export default FreightAdminStatsCards;
